import React from 'react';
import PropTypes from 'prop-types';

const Lyric = (props) => {
  return (
    <h1 className="lyric">&#8220;{props.text}&#8221;</h1>
  );
};

Lyric.propTypes = {
  text: PropTypes.string.isRequired,
};

export default Lyric;



// WEBPACK FOOTER //
// ./src/components/Lyric.js